import { privacyUrl, termsUrl } from "@/lib/env";

/** True when pathname matches an in-app legal route (env defaults or configured relative paths). */
export function isPublicLegalPath(pathname: string): boolean {
  const legalPaths = ["/legal/privacy", "/legal/terms", "/legal/delete-data"];

  if (legalPaths.includes(pathname)) {
    return true;
  }

  if (privacyUrl.startsWith("/") && pathname === privacyUrl) {
    return true;
  }

  if (termsUrl.startsWith("/") && pathname === termsUrl) {
    return true;
  }

  return false;
}
